import { createSelector } from "reselect";

import { State } from "common/types/redux";

import { makeGetSectionContents } from "./getSectionContents";
import { isSequential } from "./state/contents/content";

export default function makeGetSectionHasSequentialContent(
  sectionId: string
): (arg0: State) => boolean {
  const getSectionContents = makeGetSectionContents(sectionId);
  return createSelector(getSectionContents, contents =>
    contents.some(isSequential)
  );
}
